export function cssStringify(obj?: Record<string, unknown>): string | undefined {
	if (!obj) {
		return undefined;
	}
	return Object.keys(obj)
		.map(k => `${k}: ${obj[k]}`)
		.join(";");
}
